export type SMSTokenErrorCode = 'INVALID_TOKEN' | 'EXPIRED_TOKEN';

export class SMSTokenError extends Error {
    code: SMSTokenErrorCode;

    constructor(code: SMSTokenErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
